import { z } from 'zod';
/** Every non-2xx response from the API uses this envelope. */
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
